"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var count_1 = require("../../operator/count");
rxjs_1.Observable.prototype.count = count_1.count;
//# sourceMappingURL=count.js.map